import React, { Component } from 'react';
import imgRach from '../../../img/team/rach.jpg';
import imgRuss from '../../../img/team/russ.jpg';
import imgJen from '../../../img/team/jen.jpg';

class About extends Component {
  render () {
    return (
      <main className='main'>
        <div className='l-container l-container--narrow'>
          <h1 className='u-text-center'>A little about who we are</h1>
          <p>On 6th November 2009, the idea came to us to develop a Learning Centre that would provide and specialise in very competitively priced online British Sign Language (BSL) courses and tuition, using only award-winning, creative, flexible and highly usable technology. During Autumn, 2010, BSLcourses.co.uk was born and does exactly that.</p>
          <p>We have developed all qualification courses individually and uniquely, maximising constructive learning of all BSL skills across all Levels from novice to fluent.</p>
          <p>We also offer bespoke BSL Training courses that are designed to prepare students for both IBSL's Levels 3 and 6 Certificate qualifications and Signature's NVQ Certificate qualification.</p>
          <section className='team'>
            <div className='team__member island island--outline'>
              <h2>Rachael Parker</h2>
              <img src={imgRach} alt='Rachael Parker' />
              <p>Rachael has worked and gained a wealth of experience in teaching BSL and Deaf Awareness for over 25 years and has been very passionate in providing as much service and support to and for the deaf community, directly and indirectly.</p>
              <p>She has accumulated an impressive CV of qualifications and experience in not just teaching, or tutoring, but also as an assessor, sight translator, an Internal Verifier and an External Verifier.</p>
              <p>In November 2010, Rachael was awarded Signature’s Regional Teacher of the Year Award for South-East of England, 2010.</p>
            </div>
            <div className='team__member island island--outline'>
              <h2>Russell Fowler</h2>
              <img src={imgRuss} alt='Russell Fowler' />
              <p>Russell graduated from Stafford University with a BSc Computer Science degree but having discovered how difficult it was to find a suitable career in the IT industry, he studied from home to become qualified as a IT and Business Auditor.</p>
              <p>Armed with auditing knowledge and business processes, it was then that Rachael proposed that they joined forces to make a go at setting up BSLcourses.co.uk. Russell has always had the desire to do something about the lack of BSL Interpreters and with Rachael’s experience he is looking forward to the challenges that lay ahead!</p>
            </div>
            <div className='team__member island island--outline'>
              <h2>Jen McTaggart</h2>
              <img src={imgJen} alt='Jen McTaggart' />
              <p>Jen is the ears and voice of our company! She is a monumental part of our team taking telephone calls and email enquiries on our behalf and is an indispensable middleman between the clients, potential clients, web developers and the director to ensure the ever-growing student base receive what they need.</p>
              <p>Having gained a large experience of working with d/Deaf people in the education industry as well as growing up with a Deaf brother, Jen possesses a great understanding of our students'' needs by helping them decide on the right course or training package to achieve their ultimate goal.</p>
            </div>
          </section>
        </div>
      </main>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/views/Main/About/index.js